export const getUrlWithProtocol = (url) => {
  if (/^(https|http):\/\/(.*)/.test(url)) {
    return url;
  }

  return `https://${url}`;
};

export const getImageMeta = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;
    image.addEventListener("load", () => {
      resolve(image);
    });
    image.addEventListener("error", () => {
      reject();
    });
  });

export const getVideoMeta = (url) =>
  new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.setAttribute("controls", true);
    video.setAttribute("muted", "");
    video.setAttribute("preload", "metadata");
    video.setAttribute("crossorigin", "*");
    video.setAttribute("src", url);
    video.addEventListener("loadedmetadata", () => {
      resolve(video);
    });
    video.addEventListener("error", () => {
      reject();
    });
  });

export const getMediaRatio = (meta = {}) => {
  if (!meta.width || !meta.height) {
    return 0;
  }

  return meta.width / meta.height;
};
